import icons from '../../img/icons.svg';
import previewView from './previewView.js';
import View from './View.js';

class BookmarksView extends View {
    _parentElement = document.querySelector('.bookmarks__list');
    _errorMessage = 'No bookmarks yet added. Find a nice recipe and bookmark it (;';
    _successMessage = '';

    // We created that function for avoid the bug that we were having on the DOM update algorithm
    // which had newElements (new VirtualDOM) > currElements (Current DOM). 
    // This is because newElements contains all the elements of the bookmark container, including the results
    // and currElements contains JUST the empty state of the bookmark container so this leads to an StackTrace
    // because for each iteration, we access of position of currElements and it comes a point where it iterates more
    // than positions 'currElements' have. For fixing that, we render the bookmarks right when the page is laoded.

    addHandlerRender(handler) {
        window.addEventListener('load', handler);
    }
    _generateMarkup() {
        return this._data.map(bookmark => previewView.render(bookmark, false)).join();
    }
}

export default new BookmarksView();